export default __webpack_public_path__ + "static/media/eye-icon.8462e2c4.svg";